import React, {useEffect, useState} from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {BreadCrumb} from 'primereact/breadcrumb';
import {withTranslation} from 'react-i18next';
import {recruitmentApi} from './recruitmentApi';

const RecruitmentBreadcrumb = ({t, candidateName}) => {
  const {entity, action, id} = useParams();
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const recruitmentId = entity === 'recruitment' && id ? id : query.get('recruitmentId');
  const eventId = query.get('eventId');
  const [selection, setSelection] = useState(null);
  const [event, setEvent] = useState(null);
  useEffect(() => {
    let cancelled = false;
    setSelection(null); setEvent(null);
    const lookup = (path, value) => recruitmentApi('get', path, undefined, {'search[id][operator]': '=', 'search[id][value]': value, item_per_page: 1});
    if (recruitmentId) lookup('/recruitment', recruitmentId).then(r => {if (!cancelled) setSelection(r.data.data.items?.[0]);}).catch(() => {});
    if (eventId) lookup('/recruitment-event', eventId).then(r => {if (!cancelled) setEvent(r.data.data.items?.[0]);}).catch(() => {});
    return () => { cancelled = true; };
  }, [recruitmentId, eventId]);
  const labels = {candidate: 'candidateList', recruitment: 'recruitmentWorkflow.selections', 'event-type': 'eventTypeList', 'event-type-status': 'recruitmentWorkflow.statuses', 'recruitment-event-candidate': 'recruitmentWorkflow.applicants', dashboard: 'dashboard'};
  const parts = [{label: t('recruitmentWorkflow.module')}];
  if (recruitmentId) {
    parts.push({label: t('recruitmentWorkflow.selections'), url: '/recruitment/recruitment'});
    parts.push({label: selection?.name || `#${recruitmentId}`, url: `/recruitment/recruitment/read/${recruitmentId}`});
    if (eventId) parts.push({label: event?.name || `#${eventId}`});
    if (entity === 'recruitment-event-candidate') parts.push({label: t('candidateListSingular')});
  } else if (entity) parts.push({label: t(entity === 'candidate-import' ? 'recruitmentImport.menu' : labels[entity] || entity), url: `/recruitment/${entity}`});
  if (action && !(entity === 'recruitment' && action === 'read')) parts.push({label: action === 'create' ? t('create') : action === 'update' ? t('edit') : entity === 'candidate' ? candidateName || t('candidateListSingular') : `#${id}`});
  return <div className="PageContent p-px-5 p-pt-3 p-mx-auto"><BreadCrumb aria-label={t('recruitmentWorkflow.breadcrumb')}
    home={{icon: 'pi pi-home', command: () => history.push('/')}}
    model={parts.map((part, index) => ({label: part.label, ...(part.url && index < parts.length - 1 ? {command: () => history.push(part.url)} : {})}))}/></div>;
};
export default withTranslation('common')(RecruitmentBreadcrumb);
